import { keepPreviousData, useQuery } from '@tanstack/react-query';
import * as adminSearchService from '@/services/adminSearchService';

/** Minimum characters before the header search queries the backend. */
export const ADMIN_SEARCH_MIN_LENGTH = 2;

/** 后台全局搜索（输入少于 2 个字符时不请求） */
export function useAdminSearch(term: string) {
  const q = term.trim();
  return useQuery({
    queryKey: ['adminSearch', q],
    queryFn: () => adminSearchService.searchAdmin(q),
    enabled: q.length >= ADMIN_SEARCH_MIN_LENGTH,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
